<template>
    <div class="UserList">
    	<ListFilters
    	v-if="!justlist"
    	:totals="totals"
		:rolename="rolename"
		@update="filterUpdate"
		></ListFilters>

		<SortableTable
		:columns="columns"
		:users="list"
		@update="sortUpdate"
		></SortableTable>
    </div>
</template>

<script>
import ListFilters from '@/components/ListFilters';
import SortableTable from '@/components/SortableTable';
import forEach from 'lodash/forEach';
import isEqual from 'lodash/isEqual';

export default {
  	name: 'UserList',
	components: {
		ListFilters,
		SortableTable
	},
	data: function () {
		return {
			sort: {
				column: 'this',
				direciton: '+'
			},
			totals: {},
			filters: {},
			list: [],
			pages: 1,
		}
	},
	props: {
		justlist: {
			default: false,
		},
		apiurl: {
			default: '/api/v1/users',
		},
		listname: {
			default: 'kam',
		},
		rolename: {
			default: false, // kam
		},
		roleleadername: {
			default: false, // kam_leader
		},
		columns: {
			default(){
				return ['image', 'this', 'mainrole', 'subrole', 'leader'];
			}
		},
		forcefilters: {
			default(){
				return {}
			}
		}
	},
	mounted(){
		if(this.justlist) {
			this.update();
		}
	},
	methods: {
		// wird von ListFilters && filterUpdate gefeuert
		update: function(filters){
			var self = this;

			if(!self.apiurl) return;
			if(self.$store.getters.loadings[self.listname]) return;

			// filters
			if(typeof filters == 'undefined') filters = this.filters;
			if(typeof filters.mainrole == 'undefined') filters.mainrole = [];
			if(self.rolename && filters.mainrole.indexOf(self.rolename) == -1) filters.mainrole.push(self.rolename);
			if(self.roleleadername && filters.mainrole.indexOf(self.roleleadername) == -1) filters.mainrole.push(self.roleleadername);
			this.filters = filters;

			// sortierung

			if(this.sort && this.sort.column){
				let column = this.sort.column;
				if(this.sort.column == 'this') {
					column = ['title', 'lastname'];
				}
				if(Array.isArray(column)){
					filters.sort = [];
					forEach(column, (value) => {
						filters.sort.push((this.sort.direction == '-' ? this.sort.direction : '') + value);
					});
				} else {
					filters.sort = (this.sort.direction == '-' ? this.sort.direction : '') + column;
				}
			}

			if(this.forcefilters){
				forEach(this.forcefilters, (value, key) => {
					filters[key] = value;
				});
			}

			self.$store.commit('START_LOADING', self.listname);
			self.$api
				.get(this.apiurl, {
					params: filters
				})
				.then(response => {
					self.$store.commit('END_LOADING', self.listname);
					self.list = response.data.message;

					if(response.data.total) self.totals.all = response.data.total;
					if(response.data.total && response.data.limit){
						self.pages = Math.floor(response.data.total/response.data.limit);
					}
				}).catch(err => {
					console.error(err);
				});
		},
		filterUpdate(f){
			if(this.list.length <= 0 || !isEqual(this.filters, f)){
				this.update(f);
			}
		},
		sortUpdate(sort){
			if(this.sort != sort){
				this.sort = sort;
				this.update();
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/UserList.vue